// extracted by mini-css-extract-plugin
export default {"Boutons":"AffichageProblemePaiement_Boutons__R1UR7"};